module.exports = __webpack_public_path__ + "static/media/dandelion.62ea6855.svg";